export var OPTION_IS_COMPLEX = {
    headerToolbar: true,
    footerToolbar: true,
    events: true,
    eventSources: true,
    resources: true
};
//# sourceMappingURL=options.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@fullcalendar/vue/dist/options.js
// module id = 286
// module chunks = 1